export default "__VITE_ASSET__6441361f__"